// "+16043301122", "16043301122" or "6043301122" -> "(604) 330-1122"
export function formatPhoneNumber(value: string): string {
  const digits = value.replace(/\D/g, "");
  const match =
    digits.match(/^1(\d{3})(\d{3})(\d{4})$/) ??
    digits.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match && /^[+\d\s().-]+$/.test(value)) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return value;
}

export function isPhoneLike(value: string): boolean {
  return (
    /^[+\d\s().-]+$/.test(value) && /\d{7,}/.test(value.replace(/\D/g, ""))
  );
}

// Up to two initials, or "" for phone numbers (shown as a person icon)
export function initialsFor(name: string): string {
  if (isPhoneLike(name)) {
    return "";
  }
  return name
    .split(/[\s_-]+/)
    .filter((word) => /[A-Za-z0-9]/.test(word))
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join("");
}
